import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeReactiveContainer, sizes } from 'reactive-container';
import { buildStyledComponent, theme } from 'decisiv-ui-utils';

function getMinWidth(numberOfCards) {
  // The cardGridPadding was updated in the theme and is now a string like '0.25rem'.
  // `parseFloat()` has a quirky ability that parses floats up to the end of the numeric sequence, 
  // thus allowing it to convert '0.25rem' into 0.25 without issue ...because JavaScript.
  const gridPad = parseFloat(theme.dimensions.cardGridPadding);
  return (theme.dimensions.cardMinWidth * numberOfCards) + (gridPad * 2);
}

export const CARD_GRID_BREAKPOINTS = [
  { name: sizes.SM, minWidth: getMinWidth(2) },
  { name: sizes.MD, minWidth: getMinWidth(3) },
  { name: sizes.LG, minWidth: getMinWidth(4) },
  { name: sizes.XL, minWidth: getMinWidth(5) },
];

const styles = props => `
  padding: ${props.theme.dimensions.cardGridPadding};
  box-sizing: border-box;
`;

const themePropTypes = {
  dimensions: PropTypes.shape({
    cardGridPadding: PropTypes.string.isRequired,
  }).isRequired,
};

const CardGrid = buildStyledComponent(
  'CardGrid',
  styled.div,
  styles,
  { themePropTypes },
);

export default makeReactiveContainer()(CardGrid);




// WEBPACK FOOTER //
// ./elements/Card/ResponsiveCardGrid.js